<div class="section">
    <div class="nova__label">Job ID</div>
    <div data-qa-id="an_rjd_general_jobid_readonly">
        {{ job.id }}
    </div>   
    
    <div class="nova__label">Updated</div>
    <div data-qa-id="an_rjd_general_updated_readonly">
       <u>{{ job.updatedDate | date : "M/d/yyyy" }}</u>
    </div>   

    <div class="nova__label">Employment Type</div>
    <div data-qa-id="an_rjd_general-employment_type_readonly">
        {{ job.employmentTypeText }}
    </div>   

    <div class="nova__label">Position</div>
    <div data-qa-id="an_rjd_general_profession_readonly">
        {{ job.professionName }}
    </div>   
    
    <div class="nova__label">Specialty</div>
    <div data-qa-id="an_rjd_general_specialty_readonly">
        {{ job.specialtyName }}
    </div>   

    <div class="nova__label">Open Positions</div>
    <div data-qa-id="an_rjd_general_positions_readonly">
        {{ job.openPositions }}
    </div>   

    <div class="nova__label">Length</div>
    <div data-qa-id="an_rjd_general_duration_readonly">
        {{job.duration}}
        <span *ngIf="job.isJobDurationFlexible">(flexible)</span>
    </div>       

    <div class="nova__label">Aya Interviews</div>
    <div data-qa-id="an_rjd_general_ayainterview_readonly">
        {{ job.programDisplayName }}
    </div>       

    <div class="nova__label">Account Manager</div>
    <div data-qa-id="an_rjd_general_accountmanager_readonly">
        <a class="a-blue" href="mailto:{{job.accountManagerEmail}}"> 
            {{job.accountManagerName}} 
        </a>
    </div>
</div>